import { render, staticRenderFns } from "./ProfesionPage.vue?vue&type=template&id=b71da302"
import script from "./ProfesionPage.js?vue&type=script&lang=js&external"
export * from "./ProfesionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports